import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=49be3ba6&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=49be3ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49be3ba6",
  null
  
)

export default component.exports